import { render, staticRenderFns } from "./addShareReading.vue?vue&type=template&id=9a5a77e6"
import script from "./addShareReading.vue?vue&type=script&lang=js"
export * from "./addShareReading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports